import "./skills.scss"

// const mehboobTitle = 

export default function Skills() {
    const data = [
        {
            id: 1,
            name: "Web App Development",
            desc1:
                "React JS",
            desc2: "Next JS",
            desc3: "Tailwindcss + Bootstrap",
            desc4: "MongoDb",

        },
        {
            id: 2,
            name: "Education & Work",
            // img:
            //     "assets/Huzaifa.jpg",
            icon: "assets/linkedin.png",
            desc1:
                "Studying Software Engineering at UMT.",
            desc2: "Web Applications Developer at Affinity Devs | Oct, 2023 - Present.",
            desc3: "Open Source Contributer | GitHub",
            desc4: "Freelance Web App Developer | Upwork",
            featured: true,
        },
        {
            id: 3,
            name: "Programming Languages",
            desc1:
                "C++ (OOP + DSA)",
            desc2: "JavaScript",
            desc3: "Java (OOP + DSA)",
            desc4: "TypeScript",
        },

    ];
    return (
        <div className="testimonials" id="skills">
            <h1>Skills & Works</h1>
            <div className="container">
                {data.map((d) => (
                    <div className={d.featured ? "card featured" : "card"}>
                        <div className="top">
                        </div>
                        <div className="bottom">
                            <h3>{d.name}</h3>
                        </div>
                        <div className="center">
                            {d.desc1}
                        </div>
                        <div className="center">
                            {d.desc2}
                        </div>
                        <div className="center">
                            {d.desc3}
                        </div>
                        <div className="center">
                            {d.desc4}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}